import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { InvoiceListResponse, SendInvoiceRequest } from '../types/invoice';

export const invoiceApi = {
	getList: async (): Promise<InvoiceListResponse> => {
		return apiClient.get<InvoiceListResponse>(API_ENDPOINTS.INVOICE.LIST);
	},

	send: async (data: SendInvoiceRequest): Promise<void> => {
		return apiClient.post(API_ENDPOINTS.INVOICE.SEND, data);
	},
};
